import React, { useEffect, useState, useRef } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { Card, Table, Button, Form, Nav, Badge as BsBadge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { DOTTUYENSINH_API, BaseGatewayImage } from '@app/utils/apiUrl';
import { DeleteSingle, Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../../../utils/helper';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { 
    messageToast, 
    objectShowNumber, 
    status200,
    loaiTuyenSinhValue,
    objectLoaiTuyenSinh,
    trangThaiDotTuyenSinhValue,
    objectTrangThaiDotTuyenSinh,
    doiTuongValue,
    objectDoiTuong,
    DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT
} from '../../../../../utils/define';
import { ConfirmModal } from '../../../../../modules/modal/ConfirmModal';
import HoSoLuuTruModal from './HoSoLuuTruModal';
import ThanhToanLePhiModal from '../thanhToanLePhi/ThanhToanLePhiModal';

const DotTuyenSinh = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');
    const [namTuyenSinh, setNamTuyenSinh] = useState(new Date().getFullYear());
    const [selectedRow, setSelectedRow] = useState(null);
    const queryClient = useQueryClient();

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const [openModalLuuTru, setOpenModalLuuTru] = useState(false);
    const [dotTuyenSinhLuuTruId, setDotTuyenSinhLuuTruId] = useState('');
    const [dotTuyenSinhLuuTruName, setDotTuyenSinhLuuTruName] = useState('');

    const [openModalThanhToan, setOpenModalThanhToan] = useState(false);
    const [entityThanhToanId, setEntityThanhToanId] = useState('');
    const [entityThanhToanName, setEntityThanhToanName] = useState('');

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }
    if (paramUrl.get('nam') != null && parseInt(paramUrl.get('nam'), 10) !== namTuyenSinh) {
        setNamTuyenSinh(parseInt(paramUrl.get('nam'), 10));
    }

    const replaceHistory = (Page, Size, Search, Nam) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DOTTUYENSINH_PATH, {
                page: Page,
                size: Size,
                search: Search,
                nam: Nam
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['dotTuyenSinhData', valueSearch, page, pageSize, namTuyenSinh],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize,
                NamTuyenSinh: namTuyenSinh
            };
            replaceHistory(page, pageSize, valueSearch, namTuyenSinh);
            return Get(DOTTUYENSINH_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    const { data: listNamData } = useQuery(
        ['listNamTuyenSinh'],
        () => Get(DOTTUYENSINH_API.GET_LIST_NAM, null, null),
        { keepPreviousData: true }
    );
    const rawListNam = (Array.isArray(listNamData) ? listNamData : listNamData?.$values) || [];
    const listNam = rawListNam.length > 0 ? Array.from(new Set(rawListNam)).sort((a, b) => a - b) : [new Date().getFullYear()];

    useEffect(() => {
        if (rawListNam.length > 0 && !rawListNam.includes(namTuyenSinh)) {
            const maxYear = Math.max(...rawListNam);
            setNamTuyenSinh(maxYear);
            replaceHistory(1, pageSize, search, maxYear);
        }
    }, [listNamData, namTuyenSinh]);

    useEffect(() => {
        refetch();
    }, [pageSize, page, namTuyenSinh]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch, namTuyenSinh);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, namTuyenSinh);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search, namTuyenSinh);
    };

    const onChangeNamTuyenSinh = (e) => {
        const nam = Number(e.target.value);
        setNamTuyenSinh(nam);
        setPage(1);
        replaceHistory(1, pageSize, search, nam);
    };

    const deleteFunc = useMutation((value) => DeleteSingle(DOTTUYENSINH_API.DELETE_ITEM, value, null));

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    queryClient.invalidateQueries(['dotTuyenSinhData']);
                    refetch();
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const handleOpenModalLuuTru = (id, name) => {
        setDotTuyenSinhLuuTruId(id);
        setDotTuyenSinhLuuTruName(name);
        setOpenModalLuuTru(true);
    };

    const handleCloseModalLuuTru = () => {
        setOpenModalLuuTru(false);
        setDotTuyenSinhLuuTruId('');
        setDotTuyenSinhLuuTruName('');
    };

    const handleOpenModalThanhToan = (id, name) => {
        setEntityThanhToanId(id);
        setEntityThanhToanName(name);
        setOpenModalThanhToan(true);
    };

    const handleCloseModalThanhToan = () => {
        setOpenModalThanhToan(false);
        setEntityThanhToanId('');
        setEntityThanhToanName('');
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    useEffect(() => {
        if (items && items.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = items.find(item => item.id === prev.id);
                    return fresh || items[0];
                }
                return items[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [data]);

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    const getTrangThaiBadge = (val) => {
        let variant = 'secondary';
        if (val === trangThaiDotTuyenSinhValue.sapMo) variant = 'warning';
        else if (val === trangThaiDotTuyenSinhValue.dangMo) variant = 'success';
        else if (val === trangThaiDotTuyenSinhValue.daDong) variant = 'danger';
        else if (val === trangThaiDotTuyenSinhValue.tamDung) variant = 'secondary';
        
        const label = objectTrangThaiDotTuyenSinh.find(x => x.value === val)?.label || 'Không xác định';
        return <BsBadge variant={variant}>{label}</BsBadge>;
    };

    return (
        <div className="container-fluid">
            <Card className="card-sticky-layout card-sticky-layout-lg">
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <Nav variant="pills" className="flex-row">

                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.DOTTUYENSINH_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh Tiến sĩ</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.LOPDAOTAOLIENTUC_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh đào tạo liên tục</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link as={NavLink} to={URI_INTERNAL.LOPDAOTAOTHUCHANH_PATH} exact activeClassName="active" className="font-weight-bold">Tuyển sinh đào tạo thực hành</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <div className="d-flex align-items-center">
                            <span className="font-weight-bold mr-2">Năm:</span>
                            <Form.Control as="select" value={namTuyenSinh} onChange={onChangeNamTuyenSinh} style={{ width: '120px' }}>
                                {listNam.map((year) => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Control>
                            <NavLink to={URI_INTERNAL.DOTTUYENSINH_CREATE_PATH} className="btn btn-success ml-3">
                                Thêm mới
                            </NavLink>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body className="d-flex flex-column p-0">
                    <Card className="card-sticky-layout border-0 shadow-none flex-grow-1">
                        <Card.Body className="d-flex flex-column">
                            <div className="table-responsive flex-grow-1">
                                <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Tên đợt</th>
                                    <th className="text-center">Năm TS</th>
                                    <th>Loại tuyển sinh</th>
                                    <th>Đối tượng</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Chỉ tiêu</th>
                                    <th>Lệ phí</th>
                                    <th className="text-center">Trạng thái</th>
                                    <th style={{ width: '130px', minWidth: '130px' }}>Thời gian nhận</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={9}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={9}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={9}>Không có dữ liệu</td>
                                    </tr>
                                ) : (
                                    items.map((item, index) => (
                                        <tr 
                                            key={item.id}
                                            onClick={() => setSelectedRow(item)}
                                            className={selectedRow?.id === item.id ? 'table-primary' : ''}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <td>{(page - 1) * pageSize + index + 1}</td>
                                            <td>{item.tenDot}</td>
                                            <td className="text-center">{item.namTuyenSinh}</td>
                                            <td>{getLabelFromEnum(item.loaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue)}</td>
                                            <td>{getLabelFromEnum(item.doiTuong, objectDoiTuong, doiTuongValue)}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>
                                                {(() => {
                                                    const actualDoiTuong = item.doiTuong;
                                                    const quan = item.chiTieuQuan ?? 0;
                                                    const dan = item.chiTieuDan ?? 0;
                                                    if (actualDoiTuong === doiTuongValue.quan) return quan;
                                                    if (actualDoiTuong === doiTuongValue.khac) return dan;
                                                    if (actualDoiTuong === doiTuongValue.quanVaDan) return (
                                                        <>
                                                            Quân: {quan} <br />
                                                            Dân: {dan}
                                                        </>
                                                    );
                                                    return 0;
                                                })()}
                                            </td>
                                            <td>{new Intl.NumberFormat('vi-VN').format(item.lePhi ?? 0)}</td>
                                            <td className="text-center">{getTrangThaiBadge(item.trangThaiDotTuyenSinh)}</td>
                                            <td>
                                                {item.ngayNhanHoSo && moment(item.ngayNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT)} 
                                                {' - '}
                                                {item.ngayKetThucNhanHoSo && moment(item.ngayKetThucNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT)}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3 p-2">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>

                    <ConfirmModal
                        isOpen={openConfirmDeleteModal}
                        confirmType="delete"
                        goBackAfterDelete={false}
                        handleAccept={acceptDelete}
                        handleCancel={cancelDelete}
                        content={confirmDelMessage}
                    />

                    <HoSoLuuTruModal
                        isOpen={openModalLuuTru}
                        onClose={handleCloseModalLuuTru}
                        dotTuyenSinhId={dotTuyenSinhLuuTruId}
                        tenDot={dotTuyenSinhLuuTruName}
                    />

                    <ThanhToanLePhiModal
                        isOpen={openModalThanhToan}
                        onClose={handleCloseModalThanhToan}
                        entityId={entityThanhToanId}
                        entityName={entityThanhToanName}
                        entityType="DotTuyenSinh"
                    />
                </Card.Body>
                {!isLoading && (
                    <Card.Footer className="bg-white card-footer-sticky">
                    <div className="d-flex justify-content-end pr-4">
                        {(selectedRow?.fileDinhKem || selectedRow?.FileDinhKem) && (
                            <Button
                                variant="secondary"
                                size="sm"
                                className="mr-2"
                                onClick={() => {
                                    const fileStr = selectedRow?.fileDinhKem || selectedRow?.FileDinhKem;
                                    if (fileStr) {
                                        window.open(`${BaseGatewayImage}${fileStr}`, '_blank');
                                    }
                                }}>
                                <i className="fas fa-paperclip mr-1"></i> File đính kèm
                            </Button>
                        )}
                        <Button
                            variant="success"
                            size="sm"
                            className="mr-2 text-white"
                            disabled={!selectedRow}
                            onClick={() => handleOpenModalLuuTru(selectedRow?.id, selectedRow?.tenDot || selectedRow?.TenDot)}>
                            <i className="fas fa-archive mr-1"></i> Lưu trữ
                        </Button>
                        <Button
                            variant="warning"
                            size="sm"
                            className="mr-2 text-white"
                            disabled={!selectedRow}
                            onClick={() => handleOpenModalThanhToan(selectedRow?.id, selectedRow?.tenDot || selectedRow?.TenDot)}>
                            <i className="fas fa-credit-card mr-1"></i> Thanh toán
                        </Button>
                        <Button
                            variant="primary"
                            size="sm"
                            className="mr-2"
                            disabled={!selectedRow}
                            onClick={() => history.push(`${URI_INTERNAL.DOTTUYENSINH_EDIT_PATH}?id=${selectedRow?.id}`)}>
                            <i className="fas fa-edit mr-1"></i> Sửa
                        </Button>
                        <Button
                            variant="danger"
                            size="sm"
                            disabled={!selectedRow}
                            onClick={() => deleteAction(selectedRow?.id, selectedRow?.tenDot || selectedRow?.TenDot)}>
                            <i className="fas fa-trash mr-1"></i> Xóa
                        </Button>
                    </div>
                </Card.Footer>
                )}
                    </Card>
                </Card.Body>
            </Card>
        </div>
    );
};

export default DotTuyenSinh;


